import { useMutation } from '@tanstack/react-query';
import { toast } from '@/components/ui/use-toast';
import { handleApiError } from '@/lib/api/error';
import { orpc } from '@/lib/api/orpc';
import { orpcClient } from '@/lib/api/orpc/client';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { queryClient } from '@/lib/queryClient';
// TODO: domainがRouteの依存を持つのは避けたい。domain内部でkeyを管理するようにする
import { softwareKey } from '@/routes/_staff/software/$id/_$id/-query/key';
type Options = {
  appUserId: string;
  softwareId: string;
  onSuccess?: () => void;
};
export default function useAppUserChangeWorker({
  appUserId,
  onSuccess,
  softwareId
}: Options) {
  const {
    i18n,
    t
  } = useTranslation(defaultNS);
  return useMutation({
    mutationFn: async (personId: string) => {
      return await orpcClient.software.alertsWorkerPut({
        softwareId,
        appUserId,
        personId
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: softwareKey.all(softwareId)
      });
      await queryClient.invalidateQueries({
        queryKey: orpc.software.alertsList.key()
      });
      toast({
        title: t('domain.appUser.toast.changeWorkerSuccess')
      });
      onSuccess?.();
    },
    onError: error => {
      const {
        message
      } = handleApiError(error, {
        language: i18n.language
      });
      toast({
        title: message
      });
    }
  });
}